module.exports = __webpack_public_path__ + "static/media/city.53b655a9.png";